//#region src/qsr_automations_item_id_key.ts
var QsrAutomationsItemIdKey = /* @__PURE__ */ function(QsrAutomationsItemIdKey) {
	QsrAutomationsItemIdKey["ItemBiteId"] = "item-bite-id";
	QsrAutomationsItemIdKey["ItemBarcode"] = "item-barcode";
	return QsrAutomationsItemIdKey;
}(QsrAutomationsItemIdKey || {});
//#endregion
export { QsrAutomationsItemIdKey };

//# sourceMappingURL=qsr_automations_item_id_key.js.map